export const contentContainer = {
  width: "100%",
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  zIndex: 100,
};

export const modalTitle = {
  textTransform: "uppercase",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  marginBottom: "20px",
  lineHeight: "30px",
};

export const modalTextContent = {
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontSize: "14px",
  lineHeight: "129%",
  letterSpacing: "0.05em",
};
